import Image from "next/image";
import { useState, useEffect } from "react";
import SignupButtonComponent from "components/koach/Shared/SignupButtonComponent";

const Crossword = () => {
  return (
    <>
      <div className="bg-navy text-white flex flex-col items-center min-h-screen px-10">
        <div className="relative w-full">
          <div className="md:absolute top-0 left-0 p-10">
            <h1 className="text-4xl 2xl:text-5xl font-bold w-full text-center md:text-left text-landing-white">
              Klink
            </h1>
            <h2 className="text-3xl 2xl:text-4xl font-bold text-center md:text-left bg-gradient-to-r from-magenta to-landing-orange bg-clip-text text-transparent">
              Crossword #1
            </h2>
          </div>

          <div className="flex justify-center">
            <img
              src="/crossword/1.png"
              alt="Image"
              className="w-[100%] md:w-[80%] lg:w-[70%] xl:w-[50%] 2xl:w-[40%] h-auto"
            />
          </div>
        </div>

        {/* Row 2: Two columns with text */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-8 w-full max-w-6xl md:pb-10">
          <div className="p-4">
            <p>
              <strong>Down</strong>
            </p>
            <p>
              <strong>1. </strong>A tool within the app that helps calculate
              affordability and set your home-buying goal.
            </p>
            <p>
              <strong>2. </strong>A loan used to purchase a house.
            </p>

            <p>
              <strong>5. </strong>The Klink app helps you to save more so you
              can buy your first _______ sooner.
            </p>
            <p>
              <strong>6. </strong>The name of the app that helps you buy your
              first home quicker.
            </p>

            <p>
              <strong>8. </strong>The upfront payment made when purchasing a
              home often expressed as a percentage of the property price.
            </p>

            <p>
              <strong>10. </strong>Property ownership for a fixed number of
              years, after which ownership reverts to the freeholder.
            </p>

            <p>
              <strong>12. </strong>The financial status you need to secure a
              mortgage: good ______.
            </p>
            <p>
              <strong>13. </strong>With the Klink app’s new feature, you can set
              your home-buying _____.
            </p>

            <p>
              <strong>16. </strong>Based on your income and lender criteria, the
              Klink App will tell you how much you can ________ today.
            </p>
          </div>
          <div className="p-4">
            <p>
              <strong>Across</strong>
            </p>
            <p>
              <strong>3. </strong>A term for the physical asset you are buying.
            </p>
            <p>
              <strong>4. </strong>The process of discussing terms and conditions
              to reach an agreement in property transactions.
            </p>
            <p>
              <strong>7. </strong>The entity that provides funds for the
              mortgage.
            </p>
            <p>
              <strong>9. </strong>Gen Z and ________ love using Klink to learn
              about home buying!
            </p>
            <p>
              <strong>11. </strong>The title of the official inspector who
              conducts a home survey.
            </p>
            <p>
              <strong>14. </strong>The professional who helps with the legal
              aspects of buying a home.
            </p>
            <p>
              <strong>15. </strong>The ability to manage the cost of buying a
              home and maintain other financial obligations is known as _____.
            </p>
            <p>
              <strong>17. </strong>A sum of money borrowed from a bank or lender
              typically used to purchase a property.
            </p>
            <p>
              <strong>18. </strong>The term for the ongoing cost of borrowing.
            </p>
            <p>
              <strong>19. </strong>Money used on daily expenses, which needs to
              be managed carefully when saving for a home.
            </p>
          </div>
        </div>
        <div className="py-10">
          <SignupButtonComponent />
        </div>
      </div>
    </>
  );
};

export default Crossword;
